import axios from 'axios';
import { AppConfig, JWT } from '../config';
import { ProductPartConstant } from './constants/ProductPartConstant';
import { AlertAction } from './AlertAction';
import { Translate as t } from '../config/Translate';

const GetAll = () => async (dispatch) => {
	dispatch({ type: ProductPartConstant.LOADING });
	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/part', JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: ProductPartConstant.GET_ALL, items : ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		console.error("ProductPartAction.GetAll error:", error);
		dispatch(AlertAction.ErrorMsg("Failed to get product parts."));
	}
	dispatch({ type: ProductPartConstant.LOADED });
};

const GetAllDirect = async () => {
	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/part', JWT());
		if (ret.data.status == 'success') {
			return ret.data.data;
		} else {
			return [];
		}
	} catch (error) {
		console.error("ProductPartAction.GetAllDirect error:", error);
		return [];
	}
};

const GetAllByFilter = async (filter) => {
	const data = {
		type: 'getfilter',
		data: {...filter, isDel : false},
	};
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/part', data, JWT());
		if (ret.data.status == 'success') {
			return ret.data.data;
		} else {
			return [];
		}
	} catch (error) {
		console.error("ProductPartAction.GetAllByFilter error:", error);
		return [];
	}
};

const GetOne = (_id) => async (dispatch) => {
	dispatch({ type: ProductPartConstant.LOADING });
	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/part/' + _id, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: ProductPartConstant.GET_ONE, item : ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		console.error("ProductPartAction.GetOne error:", error);
		dispatch(AlertAction.ErrorMsg("Failed to get product part."));
	}
	dispatch({ type: ProductPartConstant.LOADED });
};

const Delete = (_id) => async (dispatch) => {
	dispatch({ type: ProductPartConstant.LOADING });
	try {
		const data = {
			type: 'delete',
			who: JSON.parse(localStorage.getItem('user')).adminid,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/part/' + _id, data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.deleted')));
			dispatch({ type: ProductPartConstant.DELETE, _id : _id });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		console.error("ProductPartAction.Delete error:", error);
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ProductPartConstant.LOADED });
};

const Create = (info) => async (dispatch) => {
	dispatch({ type: ProductPartConstant.LOADING });
	try {
		const data = {
			type: 'create',
			data: info,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/part', data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: ProductPartConstant.CREATE, item : ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		console.error("ProductPartAction.Create error:", error);
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ProductPartConstant.LOADED });
};

const AddUpdate = (info) => async (dispatch) => {
	dispatch({ type: ProductPartConstant.ADDUPDATE, item : info });
};

const Update = (_id, info, type = "update") => async (dispatch) => {
	dispatch({ type: ProductPartConstant.LOADING });
	let ok = false;
	try {
		const data = {
			type: type,
			data: info,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/part/' + _id, data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: ProductPartConstant.UPDATE, item : ret.data.data });
			ok = true;
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		console.error("ProductPartAction.Update error:", error);
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ProductPartConstant.LOADED });
	return ok;
};

export const ProductPartAction = {
	GetAll,
	GetAllDirect,
	GetOne,
	GetAllByFilter,
	Create,
	Update,
	Delete,
	AddUpdate
};
